import BrandHeroBlock from '@/blocks/BrandHeroBlock';
import BreadcrumbsBlock from '@/blocks/BreadcrumbsBlock';
import CertificateBeside from '@/blocks/CertificateBeside';
import TextImageAsideBlock from '@/blocks/TextImageAsideBlock';
import CheckList from '@/components/CheckList';
import { MEDIA_URL, REVALIDATE_TIME_IN_SEC } from '@/constants/env';
import { pages } from '@/content';
import { default as FullWidthLayout } from '@/layouts/FullWidthLayout';
import graphql from '@/lib/graphql';
import mainLayout from '@/graphql/queries/mainLayout';
import page from '@/graphql/queries/page';

export default function IndustrialProductSalesPage({ mainLayout, page }) {
  const attributes = page?.attributes || {};
  const contentSection = attributes.contentSection || [];
  const metaData = attributes.metaData || {};
  return (
    <FullWidthLayout mainLayout={mainLayout} metaData={metaData}>
      {contentSection[0]?.heroImage?.data?.attributes?.url ? (
        <BrandHeroBlock
          image={MEDIA_URL.concat(contentSection[0].heroImage.data.attributes.url)}
          title={contentSection[0].heroTitle}
        />
      ) : null}
      <BreadcrumbsBlock items={[pages.home, pages.engineering, pages.industrialProductSales]} />

      {contentSection[1]?.textImageADarkImage?.data?.attributes?.url ? (
        <TextImageAsideBlock
          image={MEDIA_URL.concat(contentSection[1].textImageADarkImage.data.attributes.url)}
          imageDirection={'left'}
          title={
            <h2 className="text-2xl font-semibold text-primary-500 md:text-3xl">
              {contentSection[1].textImageADarkTitle}
            </h2>
          }
        >
          <div className="grid sm:grid-cols-2 lg:grid-cols-1 xl:grid-cols-2">
            {splitArrayInGroups(contentSection[1].list || [], 2).map((group, i) => (
              <CheckList key={i} className="-mt-3 text-lg" items={group} />
            ))}
            {/* <CheckList className="-mt-3 text-lg" items={contentSection[1].list} /> */}
          </div>
        </TextImageAsideBlock>
      ) : null}

      {contentSection[2]?.certificateBesideImage?.data?.attributes?.url ? (
        <CertificateBeside
          image={MEDIA_URL.concat(contentSection[2].certificateBesideImage.data.attributes.url)}
          imageDirection="right"
          title={
            <h2 className="text-2xl font-semibold text-primary-500 md:text-3xl">
              {contentSection[2].certificateBesideTitle}
            </h2>
          }
        >
          <CheckList className="text-lg" items={contentSection[2].checklist || []} />
        </CertificateBeside>
      ) : null}
    </FullWidthLayout>
  );
}

export async function getStaticProps() {
  const { data: mainLayoutData } = await graphql(mainLayout);

  const { data: pageData } = await graphql(page, { slug: 'industrial-product-sales' });

  return {
    props: {
      mainLayout: mainLayoutData.mainLayout.data,
      page: pageData.pages.data[0],
    },
    revalidate: parseInt(REVALIDATE_TIME_IN_SEC), // In seconds
  };
}

/**
 * Split an array into groups
 *
 * @param {Array} array Array
 * @param {Number} groups Number of groups
 * @returns Array
 */
function splitArrayInGroups(array, groups) {
  const n = Math.ceil(array.length / groups);
  const items = array.map(({ item }, i) => item);
  return new Array(n).fill().map((_) => items.splice(0, n));
}
